import { useState } from 'react';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TotadminPermission } from 'data/__generated__';
import { PageTitle } from 'components/PageTitle';

import { NayaxMDBTemplatesList } from './components/NayaxMDBTemplatesList';
import { CreateNayaxMDBTemplatePopup } from './Popups/CreateNayaxMDBTemplatePopup';

export const NayaxMDBTemplates = () => {
    const [isCreateNayaxMDBTemplatePopupOpen, setIsCreateNayaxMDBTemplatePopupOpen] = useState<boolean>(false);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.nayaxMDBTemplates} />
                </HeaderTitle>
                <TotemPrimaryButton
                    onClick={() => setIsCreateNayaxMDBTemplatePopupOpen(true)}
                    requiredPermissions={[TotadminPermission.NayaxTemplatesManage]}
                >
                    Créer un template
                </TotemPrimaryButton>
            </Header>
            <NayaxMDBTemplatesList />
            <CreateNayaxMDBTemplatePopup
                isOpen={isCreateNayaxMDBTemplatePopupOpen}
                setIsOpen={setIsCreateNayaxMDBTemplatePopupOpen}
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;
